// @flow
import * as React from 'react';

import { ChevronRight } from 'lucide-react';
import { View, Actionable } from 'reshaped';
import type { ViewProps } from 'reshaped';

import { Icon } from '@gandi/reshaped';

import { useModalContext } from 'src/Layout/context/Modal';

import type { ModalType } from '../hooks/useModalType';

type Props = {
  children: React.Node,
  disabled?: boolean,
  type: ModalType,
  ...ViewProps<>,
};

export function ActionBlock({
  children,
  disabled,
  type,
  ...extraProps
}: Props): React.MixedElement {
  const context = useModalContext();

  const [active, setActive] = React.useState(false);

  const handleClick = () => {
    setActive(true);
    context.openModal({ type, replace: true });
  };

  React.useEffect(() => {
    if (!context.active) setActive(false);
  }, [context.active]);

  const activeCurrently = active && context.active && !disabled;

  return (
    <Actionable onClick={handleClick} disabled={disabled}>
      <View
        borderColor={activeCurrently ? 'primary' : 'neutral'}
        borderRadius="large"
        backgroundColor="elevation-base"
        padding={7}
        paddingEnd={4}
        gap={4}
        align="center"
        justify="space-between"
        direction="row"
        wrap={false}
        {...extraProps}
      >
        {children}
        <Icon svg={ChevronRight} size={5} />
      </View>
    </Actionable>
  );
}
